import React from "react";
import { View, Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";
import Accordion from "../../../components/Accordion";
import IntentBox from "../../../components/IntentBox";
import { Platform, StyleSheet, FlatList } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { QuestionAnswerView } from "./QuestionAndAnswer";
import { NoLeads } from "./MainSection";
import NoteField from "./NoteField";

export const LeadList = ({
  data,
  isTablet,
  pingTime,
  localAttendees,
  startTime,
  completedAt,
  isFetched,
  uuid,
  user,
  syncing,
}: {
  data: any[];
  isTablet: boolean;
  pingTime: number | null;
  localAttendees: boolean;
  startTime: any;
  completedAt: any;
  isFetched: boolean;
  uuid: string;
  user: any;
  syncing?: boolean;
}) => {
  const [list, setList] = React.useState<any[]>([]);
  React.useEffect(() => {
    if (data) {
      const updatedList = data.map((attendee) => {
        const isSynced = attendee?.is_synced || attendee?.uuid;
        return {
          ...attendee,
          is_synced: isSynced,
        };
      });
      setList(updatedList);
    }
  }, [data]);
  const ListItem = ({
    text,
    width,
    syncStatus,
  }: {
    text: string;
    width: number;
    syncStatus: boolean;
  }) => (
    <View
      style={{
        flex: width,
        height: 20,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Ionicons
        name={syncStatus ? "cloud-done-outline" : "cloud-outline"}
        size={18}
        color={syncStatus ? Colors.go_blue_600 : Colors.nuetral_grey_600}
        style={{ marginRight: 8 }}
      />
      <Text
        lineHeight={Platform.OS === "web" ? 0 : 20}
        lightColor={Colors.nuetral_grey_700}
      >
        {text}
      </Text>
    </View>
  );

  const renderItem = ({ item: attendee }: { item: any }) => (
    <Accordion
      note={attendee?.note}
      headerSection={
        <View style={styles.listItem}>
          <ListItem
            syncStatus={attendee?.is_synced || attendee?.uuid}
            text={`${attendee?.first_name || "N/A"} ${
              attendee?.last_name || "N/A"
            }`}
            width={isTablet ? 0.3 : 0.5}
          />
          <View
            style={{ flex: isTablet ? 0.2 : 0.5, flexDirection: "row", gap: 8 }}
          >
            {attendee?.intent === "seller/buyer" ? (
              <>
                <IntentBox intent="buyer" />
                <IntentBox intent="seller" />
              </>
            ) : (
              <IntentBox intent={attendee?.intent} />
            )}
          </View>
          {isTablet && (
            <>
              <View style={{ flex: 0.3 }}>
                <Text lightColor={Colors.nuetral_grey_700}>
                  {attendee?.email}
                </Text>
              </View>
              <View style={{ flex: 0.3 }}>
                <Text lightColor={Colors.nuetral_grey_700}>
                  {attendee?.phone}
                </Text>
              </View>
            </>
          )}
        </View>
      }
      bodySection={
        <>
          {!isTablet && (
            <View style={{ gap: 8 }}>
              <View>
                <Text lightColor={Colors.nuetral_grey_600}>Email</Text>
                <Text lightColor={Colors.nuetral_grey_700}>
                  {attendee?.email || "N/A"}
                </Text>
              </View>
              <View>
                <Text lightColor={Colors.nuetral_grey_600}>Phone Number</Text>
                <Text lightColor={Colors.nuetral_grey_700}>
                  {attendee?.phone || "N/A"}
                </Text>
              </View>
              <View>
                <Text lightColor={Colors.nuetral_grey_600}>Agent</Text>
                <Text lightColor={Colors.nuetral_grey_700}>
                  {attendee?.agent || "N/A"}
                </Text>
              </View>
            </View>
          )}

          {attendee?.collectedForm &&
            (() => {
              const qa = attendee.collectedForm.collectedQuestionsAndAnswers;

              if (!qa) return null;

              if (Array.isArray(qa)) {
                return qa.map((question: any) => (
                  <QuestionAnswerView
                    key={question.question_uuid || Math.random().toString()}
                    question={question.question || question.questionText}
                    answer={
                      question.answers?.[0]?.label ||
                      question.answers?.[0]?.value
                    }
                  />
                ));
              }

              return Object.keys(qa).map((questionUuid: string) => (
                <QuestionAnswerView
                  key={questionUuid}
                  question={qa[questionUuid][0]?.questionText}
                  answer={qa[questionUuid][0]?.answer}
                />
              ));
            })()}

          <NoteField
            attendee={attendee}
            uuid={uuid}
            user={user}
            pingTime={pingTime}
            updateAttendees={setList}
          />
        </>
      }
    />
  );

  return (
    <FlatList
      contentContainerStyle={styles.listItems}
      data={list || []}
      keyExtractor={(item) => item.uuid || Math.random().toString()}
      renderItem={renderItem}
      ListHeaderComponent={
        syncing ? (
          <View style={{ paddingVertical: 16, alignItems: "center" }}>
            <Text lightColor={Colors.nuetral_grey_600} size={16}>
              Syncing leads...
            </Text>
          </View>
        ) : null
      }
      ListEmptyComponent={
        isFetched && (
          <NoLeads
            pingTime={pingTime}
            startTime={startTime}
            isTablet={isTablet}
            completedAt={completedAt}
          />
        )
      }
    />
  );
};

const styles = StyleSheet.create({
  listItems: {
    paddingBottom: 16,
  },
  listItem: {
    flex: 1,
    flexDirection: "row",
    paddingVertical: 12,
    alignItems: "center",
    justifyContent: "center",
  },
});
